import { lazyPage, type ModulePlugin } from "@keel/core";
import { PayrollTile } from "./Tile";

const runs = () => import("./Runs");
const rules = () => import("./Rules");
const PayRuns = lazyPage(runs, "PayRuns");
const PayRunPage = lazyPage(runs, "PayRunPage");
const PayslipPage = lazyPage(runs, "PayslipPage");
const EmployeePayslips = lazyPage(runs, "EmployeePayslips");
const RuleSets = lazyPage(rules, "RuleSets");
const CountryRules = lazyPage(rules, "CountryRules");
const GeneralRules = lazyPage(rules, "GeneralRules");

/** Payroll (optional module): pay runs, payslips, salary rules per country and company-wide. */
const plugin: ModulePlugin = {
  key: "payroll",
  help: () => import("./help"),
  nav: [
    {
      group: "People",
      items: [
        { to: "/payroll", label: "Pay runs", icon: "wallet", perm: "payroll.runs.read", end: true },
        { to: "/payroll/rules", label: "Salary rules", icon: "sliders", perm: "payroll.runs.read" },
      ],
    },
  ],
  routes: [
    { path: "/payroll", element: <PayRuns /> },
    { path: "/payroll/runs/:id", element: <PayRunPage /> },
    { path: "/payroll/payslips/:id", element: <PayslipPage /> },
    { path: "/payroll/rules", element: <RuleSets /> },
    { path: "/payroll/rules/general", element: <GeneralRules /> },
    { path: "/payroll/rules/:id", element: <CountryRules /> },
  ],
  commands: [
    ["Pay runs", "/payroll", "wallet", "payroll.runs.read"],
    ["Salary rules & countries", "/payroll/rules", "sliders", "payroll.runs.read"],
    ["Company-wide pay rules", "/payroll/rules/general", "sliders", "payroll.runs.read"],
  ],
  sources: { pay_run: "/payroll/runs/" },
  employeeTabs: [
    { key: "payslips", label: "Payslips", perm: "payroll.payslips.view", component: EmployeePayslips },
  ],
  dashboardTiles: [{ key: "payroll", section: "payroll", perm: "payroll.runs.read", component: PayrollTile }],
};
export default plugin;
